export default __webpack_public_path__ + "images/2c50f2ee2500c3c65d0b2eb43744ce72-dallas_mobile.webp";